import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { visitFilterLabelMap } from '../../../utils/const'
import { CellAction } from './CellAction'
import { columnHelper, isBrowser } from './columnHelper'
import { NotApplicable, Unavailable } from './MissingData'

const key = IdentificationUrlKeys.DeviceRarity
const label = visitFilterLabelMap[key]

export const deviceRarityColumn = () =>
  columnHelper.display({
    id: 'deviceRarity',
    header: 'Rare device',
    cell: ({ row }) => {
      if (!isBrowser(row.original)) {
        return <NotApplicable />
      }

      // Product id is `device_rarity`; the emitted event field is `rare_device`.
      const result = row.original.rare_device

      if (result == null) {
        return <Unavailable />
      }

      return (
        <CellAction search={(old) => ({ ...old, [key]: result })} field={label}>
          <Typography className={result ? 'text-red-800' : ''}>{result ? 'Yes' : 'No'}</Typography>
        </CellAction>
      )
    },
  })
